import {
  ExistsElement,
  GetInputValue,
  SetAttribute,
  RemoveAttribute,
  SetStyle,
} from "@/libs/cart/utility";
import $ from "jquery";

export type ShowInitialCartView = (
  existsElement: ExistsElement,
  getInputValue: GetInputValue,
  setAttribute: SetAttribute,
  triggerSelector: string,
  checkedSelector: string
) => (openMenu: any) => void;

export type SetStyleByScrollArea = (
  existsElement: ExistsElement,
  aggregateElementsHeight: AggregateElementsHeight,
  setStyle: SetStyle,
  selector: string
) => (height: number, maxHeight: number) => void;

export type UpdateEmptyStateOfCartItems = (
  existsElement: ExistsElement,
  getInputValue: GetInputValue,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  selector: string,
  orderItemsCountSelector: string
) => (quantity: number) => void;

export type AggregateElementsHeight = (elements: HTMLElement[]) => number;

/**
 * 要素の存在確認をし、存在した場合メニューを開く関数と属性を設定する関数を実行する
 * @param existsElement 要素の存在確認を行う関数
 * @param getInputValue 要素の値を取得する関数
 * @param setAttribute 属性を設定する関数
 * @param triggerSelector トリガー用セレクタ
 * @param checkedSelector チェック用セレクタ
 */
export const showInitialCartView: ShowInitialCartView = (
  existsElement,
  getInputValue,
  setAttribute,
  triggerSelector,
  checkedSelector
) => (openMenu) => {
  if (!existsElement(triggerSelector) || getInputValue(triggerSelector) !== "1")
    return;
  openMenu();
  setAttribute(checkedSelector, "checked", "checked");
};

/**
 * 要素の存在確認をし、存在した場合受け取った値からスクロールエリアの高さのスタイルをセットする
 * @param existsElement 要素の存在確認を行う関数
 * @param aggregateElementsHeight 要素の高さを集計する関数
 * @param setStyle スタイルを付与する関数
 * @param selector 指定した要素
 */
export const setStyleByScrollArea: SetStyleByScrollArea = (
  existsElement,
  aggregateElementsHeight,
  setStyle,
  selector
) => (height, maxHeight) => {
  if (!existsElement(selector)) return;
  const $scrollArea = $(selector);
  const elements = $.makeArray(
    $scrollArea.children().not("script").not("[hidden=hidden]")
  );
  const scrollAreaHeight = aggregateElementsHeight(elements);
  const fixedAreaHeight = height - scrollAreaHeight;
  const scrollableHeight = maxHeight - fixedAreaHeight;
  setStyle(selector, { maxHeight: scrollableHeight });
};

/**
 * 要素の存在確認をし、受け取った追加商品とお届け予定商品の合計数によってエンプティステートの表示を切り替える
 * @param existsElement 要素の存在確認を行う関数
 * @param setAttribute 属性を設定する関数
 * @param removeAttribute 属性を削除する関数
 * @param selector エンプティステートセレクタ
 * @param orderItemsCountSelector 追加商品数取得用セレクタ
 */
export const updateEmptyStateOfCartItems: UpdateEmptyStateOfCartItems = (
  existsElement,
  getInputValue,
  setAttribute,
  removeAttribute,
  selector,
  orderItemsCountSelector
) => (quantity) => {
  if (!existsElement(selector) || !existsElement(orderItemsCountSelector))
    return;
  getInputValue(orderItemsCountSelector) === "0" && quantity <= 0
    ? removeAttribute(selector, "hidden")
    : setAttribute(selector, "hidden", "true");
};

/**
 * 要素の配列を受け取り、高さの値を集計する
 * @param elements HTMLエレメントら
 * @returns 高さの合計値
 */
export const aggregateElementsHeight: AggregateElementsHeight = (elements) =>
  elements.reduce((s, i) => {
    const height = $(i).outerHeight(true);
    return s + (height ? height : 0);
  }, 0);
